import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    parentClass: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      marginTop: '28px',
      gap: '24px',
      '@media (max-width: 600px)': {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        left: 0,
        padding: '16px',
        boxSizing: 'border-box',
        flexDirection: 'row',
        alignItems: 'stretch',
        justifyContent: 'center',
        gap: '16px',
        borderTop: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
        marginTop: 0,
        backgroundColor: STYLE.COLOR.WHITE,
        zIndex: 9,
        '& .MuiButton-root': {
          flex: '1 1 0',
          width: 'auto',
          minWidth: '0 !important',
          maxWidth: 'none',
        },
      },
    },
  }),
);
